import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-bottom" }

import '@/assets/styles/footer.css';

export default /*@__PURE__*/_defineComponent({
  __name: 'FooterImpressum',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"footer-container\"><div class=\"footer-block\"><h3>Gallus Pflegedienst e.K.</h3><p> Gallus Pflegedienst e.K.<br> Inhaber: Mileva Markovic<br> Am Niedwald 53<br> 65933 Frankfurt am Main </p><p> Tel: <a href=\"tel:+496975009899\">069 75009899</a><br> E-Mail: <a href=\"mailto:info@galluspflegedienst.de\"> info@galluspflegedienst.de </a><br> Fax: <a href=\"fax:+496975084926\">069 75084926</a></p></div><div class=\"footer-block\"><h3>Rechtliches</h3><p> Berufsbezeichnung: Pflegefachkraft<br> Verliehen in Deutschland<br> Zuständige Aufsichtsbehörde: Gesundheitsamt Frankfurt am Main </p></div><div class=\"footer-block\"><h3>Links</h3><ul><li><a href=\"/impressum\">Impressum</a></li><li><a href=\"/datenschutz\">Datenschutz</a></li></ul></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, "© " + _toDisplayString(new Date().getFullYear()) + " Gallus Pflegedienst e.K.", 1),
      _cache[0] || (_cache[0] = _createElementVNode("p", { class: "creator" }, "Webdesign & Entwicklung: Butterweck Digital", -1))
    ])
  ]))
}
}

})